export default "__VITE_ASSET__CV4en81b__"